export default __webpack_public_path__ + "static/media/runIllustration.1b7465f4.png";